module.exports = __webpack_public_path__ + "static/media/hackerMap.35fa07b8.png";